export default __webpack_public_path__ + "static/media/bluemoon-logo.3143be56.svg";